/* eslint-disable no-redeclare */
import { NonEmptyText } from '@hc-frontend/core-types';
import { z } from 'zod';

export const DecryptParamsRequest = z.object({
  data: NonEmptyText,
});

export const DecryptParamsResponse = z.object({
  data: z.string(),
});

export type DecryptParamsRequest = z.infer<typeof DecryptParamsRequest>;
export type DecryptParamsResponse = z.infer<typeof DecryptParamsResponse>;
